import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosDesarrollo/Pescadores/65d5078fadfb9ddaf7a6b797_Edificio A  01.jpg"
import image2 from "../../../Img/Proyectos/ProyectosDesarrollo/Pescadores/65d5079d9ed432e920407f23_Edificio A  02.jpg"
import image3 from "../../../Img/Proyectos/ProyectosDesarrollo/Pescadores/65d5078bcddc61efbc399cd8_Conjunto 03.jpg"
import image4 from "../../../Img/Proyectos/ProyectosDesarrollo/Pescadores/65d5079d9f27b18096816b90_Conjunto 01.jpg"
import image5 from "../../../Img/Proyectos/ProyectosDesarrollo/Pescadores/65d5079e0aab4065d55c764a_Edificio B  01.jpg"


function ProyectoPescadores() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Playa y Montaña - Pescadores</title>
            </Helmet>

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-casas-de-descanso">Playa y Montaña</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Pescadores</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Pescadores</h1>
                <h6 className="py-2 m-0 p-0">Sayulita, Nay.<h6>2016</h6></h6>
            </div>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5
                ]}

                slide={lightboxController.slide}
            />

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>
                

                </div>
            </div>
        </>
    );
}

export default ProyectoPescadores;
